import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from 'primeng/api';
import { EffectsModule } from '@ngrx/effects';
import { MessagesModule } from 'primeng/messages';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import {
    MD5Pipe,
    UrlEncodePipe,
    PaginationComponent,
    AddressFormComponent,
    UserInfoTooltipComponent,
} from '@qwyk/ui-standalone';

import * as fromNotifications from './+state/notifications.reducer';
import { NotificationsFacade } from './+state/notifications.facade';
import { NotificationsEffects } from './+state/notifications.effects';
import { components, NotificationsListWidgetComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
        MD5Pipe,
        RouterModule,
        MomentModule,
        SharedModule,
        UrlEncodePipe,
        MessagesModule,
        TranslateModule,
        FontAwesomeModule,
        PaginationComponent,
        AddressFormComponent,
        UserInfoTooltipComponent,
        StoreModule.forFeature(
            fromNotifications.NOTIFICATIONS_FEATURE_KEY,
            fromNotifications.reducer
        ),
        EffectsModule.forFeature([NotificationsEffects]),
    ],
    declarations: components,
    providers: [NotificationsFacade],
    exports: [NotificationsListWidgetComponent],
})
export class HubNotificationsWithoutRoutingModule {}
